/**
 * Export for transfer: the package a client takes to another provider
 * (website edit page, Backups tab, super admins only).
 */
export default {
    card: {
        title: 'Export for transfer',
        intro: 'A package for a client who is moving to another provider: the website and its data in one zip. Building it can take a while for a large site. A finished export can be downloaded for 7 days, then it is removed.',
        introAdmin: 'When you move this website to another provider, we make this package for you: the website and its data in one zip. A finished export can be downloaded here for 7 days, then it is removed.',
        // Each follows the name of the folder or file in the zip.
        contents: {
            site: 'a static HTML copy of the public website that can be put on any host. Forms, cart, checkout, customer accounts and search do not work in it.',
            theme: 'the theme source.',
            data: 'customers, addresses, orders, order lines, newsletter subscribers, form submissions with their attachments, and the products as a Shopify-compatible CSV with their images.',
            readme: 'explains what is in the package.',
        },
        personalData: 'The package holds personal data. Once it is handed over, the client becomes its controller, so only give it to the client whose website this is.',
        create: 'Create export',
        busy: 'An export is being built. A new one can be created once it has finished.',
        empty: 'No exports yet.',
        columns: {
            requestedBy: 'Requested by',
            size: 'Size',
            expires: 'Expires',
        },
        expired: 'expired',
        confirmDelete: 'Delete?',
        deleteExport: 'Delete export',
        failedNoReason: 'The export failed without giving a reason.',
    },
    status: {
        queued: 'queued',
        running: 'running',
        done: 'done',
        failed: 'failed',
    },
    createDialog: {
        title: 'Create an export for transfer?',
        crawl: 'This crawls the live website to make the static copy, which can take a while for a large site.',
        personalData: "It also copies the website's customers, orders, newsletter subscribers and form submissions into the package. That is personal data: only hand the download to the client it belongs to.",
    },
};
